import type { ContactFilter, PropertyFilter } from "@/types/entities";

type ListScope = Pick<ContactFilter, "legalEntityId" | "branchId">;

/** Branch selected → branchId only; All branches → legalEntityId only. */
export function contactPropertyListScope(
  legalEntityId: string | null | undefined,
  branchId: string | null | undefined,
): ListScope {
  const branch = branchId?.trim();
  if (branch) return { branchId: branch };
  const entity = legalEntityId?.trim();
  if (entity) return { legalEntityId: entity };
  return {};
}

export function normalizeContactPropertyListFilter<T extends ContactFilter | PropertyFilter>(
  filter: T,
): T {
  const branch = filter.branchId?.trim();
  if (branch) {
    const { legalEntityId: _legalEntityId, ...rest } = filter;
    return { ...rest, branchId: branch } as T;
  }
  const entity = filter.legalEntityId?.trim();
  if (entity) {
    const { branchId: _branchId, ...rest } = filter;
    return { ...rest, legalEntityId: entity } as T;
  }
  const { legalEntityId: _legalEntityId, branchId: _branchId, ...rest } = filter;
  return rest as T;
}
